import React, { useEffect } from "react"
import { Switch, Route, useHistory } from "react-router-dom"

import Header from "../../components/header"
import Sidebar from "../../components/sidebar"
import GuidesContainer from "./Guides/GuidesPage"
import EditGuideContainer from "./Guides/Edit/EditGuidePage"
import DestinationSettingsContainer from "./Settings/SettingsPage"
import ExamplesContainer from "./Examples"
import ErrorContainer from "../Error/404"
import { useDestination } from "../../hooks/useDestinations"
import { useSelectedProject } from "../../contexts/SelectedProjectContext"

const HomeContainer: React.FC = () => {
  const history = useHistory()
  const { selectedDestinationId } = useSelectedProject()
  const { data: selectedDestination } = useDestination(selectedDestinationId)

  useEffect(() => {
    if (!selectedDestinationId) {
      history.push("/handbooks")
    }
  }, [history, selectedDestinationId])

  return (
    <>
      <Header />
      <div className="tw-has-header tw-has-sidebar">
        <div className="xl:tw-container tw-mx-auto tw-w-full tw-px-4 sm:tw-px-12">
          <Switch>
            <Route exact path="/handbook/examples" component={ExamplesContainer} />
            <Route exact path="/handbook/guides" component={GuidesContainer} />
            <Route exact path="/handbook/guides/:id" component={EditGuideContainer} />
            <Route exact path="/handbook/details" component={DestinationSettingsContainer} />
            <Route path="*" component={ErrorContainer} />
          </Switch>
        </div>
      </div>
      <Sidebar type="handbook" selectedProject={selectedDestination} />
    </>
  )
}

export default HomeContainer
